<template>
  <b-card
    no-body
    class="font-weight-bold"
    :class="
      scheduleDetails.reserve && scheduleDetails.reserve.length > 0
        ? 'schedule-card-border-reserved'
        : 'schedule-card-border-free'
    "
  >
    <b-card-header
      class="text-center d-flex flex-row align-items-center justify-content-between"
      :class="
        scheduleDetails.reserve && scheduleDetails.reserve.length > 0
          ? 'schedule-card-bg-reserved'
          : 'schedule-card-bg-free'
      "
    >
      <h4 class="text-left text-white">
        تاریخ:
        {{ new Date(scheduleDetails.startTime).toLocaleDateString("fa-IR") }}
      </h4>
      <b-button
        @click="getDeleteConfirmationForSchedule(scheduleDetails)"
        class="p-0"
        variant="transparent"
        :class="
          scheduleDetails.reserve && scheduleDetails.reserve.length > 0
            ? 'cursor-not-allowed'
            : 'cursor-pointer'
        "
        :disabled="
          scheduleDetails.reserve && scheduleDetails.reserve.length > 0
        "
      >
        <feather-icon icon="Trash2Icon" class="text-white" size="20" />
      </b-button>
    </b-card-header>
    <b-card-text>
      <p class="text-center mt-2 font-weight-bolder">
        روز
        {{
          new Date(scheduleDetails.startTime).toLocaleDateString("fa-IR", {
            weekday: "long",
          })
        }}
      </p>
      <p class="text-center mt-2">
        از ساعت
        {{
          new Date(scheduleDetails.startTime).toLocaleTimeString("fa-IR", {
            hour: "2-digit",
            minute: "2-digit",
          })
        }}
        تا ساعت
        {{
          new Date(scheduleDetails.endTime).toLocaleTimeString("fa-IR", {
            hour: "2-digit",
            minute: "2-digit",
          })
        }}
      </p>
      <div
        class="w-100 d-flex flex-column align-items-center justify-content-center pb-2"
      >
        <b-button
          @click="renderVipReserveModal"
          size="sm"
          variant="primary"
          class="mb-1"
        >
          رزرو تایم VIP
        </b-button>

        <b-button
          size="sm"
          type="button"
          v-b-toggle="`reserved-collapse-${scheduleDetails.masterScheduleId}`"
          variant="success"
          v-if="
            (scheduleDetails.reserve && scheduleDetails.reserve.length > 0) ||
            (scheduleDetails.vipReserveUsers &&
              scheduleDetails.vipReserveUsers.length > 0)
          "
        >
          مشاهده زمان های رزرو شده
        </b-button>
        <b-collapse
          :id="`reserved-collapse-${scheduleDetails.masterScheduleId}`"
          class="mt-2"
        >
          <div
            class="w-100 d-flex flex-column align-items-center justify-content-center"
          >
            <b-badge
              variant="danger"
              class="font-weight-normal mb-1"
              v-for="(reserve, index) in scheduleDetails.reserve"
              :key="index"
            >
              مدت:
              {{ reserve.duration }}
              دقیقه - از
              {{
                new Date(reserve.startTime).toLocaleTimeString("fa-IR", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              }}
              تا
              {{
                new Date(reserve.endTime).toLocaleTimeString("fa-IR", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              }}
            </b-badge>
            <div
              class="d-flex align-items-center"
              v-for="vipReserve in scheduleDetails.vipReserveUsers"
            >
              <b-badge
                v-b-modal.modal-vip-reserve-update
                @click="renderVipUpdateModal(vipReserve)"
                variant="primary"
                class="font-weight-normal mb-1"
              >
                از
                {{
                  new Date(vipReserve.startDate).toLocaleTimeString("fa-IR", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                }}
                تا
                {{
                  new Date(vipReserve.endDate).toLocaleTimeString("fa-IR", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                }}
                (VIP) - ({{ vipReserve.isUsed ? "تایید شده" : "تایید نشده" }})
              </b-badge>
              <feather-icon
                v-if="!vipReserve.isUsed"
                v-b-modal.modal-vip-reserve-delete
                @click="renderDeleteVipReserveUserModal(vipReserve)"
                class="cursor-pointer text-danger mb-1 ml-1"
                icon="Trash2Icon"
                size="18"
              />
            </div>
          </div>
        </b-collapse>
      </div>
    </b-card-text>
    <vip-user-modal-create
      v-if="!isResetingVipCreateModal"
      :scheduleDetails="scheduleDetails"
      @loading="loading"
      @loaded="loaded"
      @updateMasterPeriods="updateMasterPeriods"
      @resetCreateVipModal="resetVipUserCreateModal"
      :availableWeekDays="availableWeekDays"
    ></vip-user-modal-create>
    <vip-user-modal-update
      @updateMasterPeriods="updateMasterPeriods"
      v-if="tempVipReserve"
      :vipUserReserve="tempVipReserve"
      :scheduleDetails="scheduleDetails"
    ></vip-user-modal-update>
    <vip-user-modal-delete
      v-if="tempVipReserveForDelete"
      :vipReserveForDelete="tempVipReserveForDelete"
      @updateMasterPeriods="updateMasterPeriods"
    >
    </vip-user-modal-delete>
  </b-card>
</template>
<script>
export default {
  directives: {
    "b-toggle": VBToggle,
  },
  props: {
    scheduleDetails: {
      type: Object,
      required: true,
    },
    availableWeekDays: {
      type: Array,
      required: true,
    },
  },
  emits: [
    "getDeleteConfirmationForSchedule",
    "loading",
    "loaded",
    "updateMasterPeriods",
  ],
  data() {
    return {
      vipUserReserveDetails: {
        id: 0,
        userId: null,
        startDate: null,
        endDate: null,
        expireTime: null,
      },
      tempVipReserve: null,
      tempVipReserveForDelete: null,
      isResetingVipCreateModal: false,
    };
  },
  methods: {
    loading() {
      this.$emit("loading");
    },
    loaded() {
      this.$emit("loaded");
    },
    renderDeleteVipReserveUserModal(vipUserReserve) {
      this.tempVipReserveForDelete = JSON.parse(JSON.stringify(vipUserReserve));
    },
    updateMasterPeriods() {
      this.resetVipUserCreateModal();
      this.$emit("updateMasterPeriods");
    },
    resetVipUserCreateModal() {
      this.isResetingVipCreateModal = true;
      setTimeout(() => {
        this.isResetingVipCreateModal = false;
      }, 200);
    },
    renderVipUpdateModal(vipReserve) {
      if (!vipReserve.isUsed) {
        this.tempVipReserve = JSON.parse(JSON.stringify(vipReserve));
        this.$bvModal.show("modal-vip-reserve-update");
      }
    },
    renderVipReserveModal() {
      this.$bvModal.show(
        `modal-vip-reserve-${this.scheduleDetails.masterScheduleId}`
      );
    },
    getDeleteConfirmationForSchedule(schedule) {
      this.$emit("getDeleteConfirmationForSchedule", schedule);
    },
  },
  components: {
    BCard,
    BCollapse,
    BCardText,
    BCardHeader,
    BButton,
    BBadge,
    VipUserPicker,
    VipUserModalUpdate,
    VipUserModalCreate,
    VipUserModalDelete,
  },
};
import {
  BCard,
  BCollapse,
  BCardText,
  BCardHeader,
  BButton,
  BBadge,
  VBToggle,
} from "bootstrap-vue";
import VipUserPicker from "@/views/components/VipUser/VipUserPicker.vue";
import VipUserModalUpdate from "@/views/components/VipUser/VipUserModalUpdate.vue";
import VipUserModalCreate from "@/views/components/VipUser/VipUserModalCreate.vue";
import VipUserModalDelete from "@/views/components/VipUser/VipUserModalDelete.vue";
</script>
<style scoped>
.schedule-card-bg-free {
  background-color: #007bff;
}
.schedule-card-bg-reserved {
  background-color: #c40000;
}
.schedule-card-border-free {
  border: 1px solid #007bff;
}
.schedule-card-border-reserved {
  border: 1px solid #c40000;
}
</style>
